import application from 'application/application';

import template from './process-list.template.html';

import controller from './process-list.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider.state('root.default.movements.processList', {
			url:
				'/processos?paginaAtual&pasta&processo&tribunal&fonte&nomePasta&search',
			views: {
				'movements@root.default.movements': {
					templateUrl: template,
					controller
				}
			}
		});
	}
]);
